/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';

export const scanProcessingIdle = createAction('scan/PROCESSING_IDLE');

export const scanProcessingStarted = createAction('scan/PROCESSING_STARTED');

export const scanProcessingFailed = createAction('scan/PROCESSING_FAILED');

export const scanProcessingSucceed = createAction('scan/PROCESSING_SUCCEED');
